<template>
    <div class="shenpi">
        <div class="boxing">
            <div class="box">
                <div class="box-top"><span v-for="(item,index) in data" :key="index" @click="dabumen(item,index)">{{item.name}}<span v-if="index<data.length-1"> >
                    </span></span></div>
            </div>
        </div>
        <div class="boxing">
            <div class="box">
                <div class="box-center" v-for="(item,index) in deptInfo" :key="index" @click="bumen(item)">
                    <div class="div1">{{item.name}}</div>
                    <div class="div2"></div>
                </div>
            </div>
        </div>
        <div class="boxing">
            <div class="box" style="margin-bottom:4rem">
            <div class="box-bottom">
                <div class="box-bottom-content" v-for="(item,index) in dataInfo" :key="index">
                    <van-checkbox v-model="item.checked" icon-size="30px" checked-color="#00B893" @click="xuanzhong(item)"></van-checkbox>
                    <div class="img">{{item.name.slice(0,1)}}</div>
                    <div class="div">{{item.name}}</div>
                </div>
            </div>
        </div>
        </div>
        <div class="bottom">
            <div class="bottom-box">
                <div>已选择{{date.length}}人</div>
                <van-button type="primary" style="background:#FFA900;border:0px" @click="confirm">确认({{date.length}}/{{dataInfo.length}})</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {getSchool,getStudents}from "@/api/http"
import { Checkbox, CheckboxGroup,Button,Toast } from 'vant';

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Toast);
export default {
    data(){
        return{
            currentInfo:JSON.parse(window.sessionStorage.getItem("currentInfo")),//当前登陆人的信息
            checked:false,
            schoolInfo:[],//存储学校信息
            deptInfo:[],//存储次一级信息
            dataInfo:[],//存储人员信息
            data:[],//最上面的面包屑
            date:[],//选中的人的信息
            type:true,//判断是从哪个页面跳转过来的
        }
    },
    methods:{
        //点击确认提交
        confirm(){
            window.sessionStorage.setItem("date",JSON.stringify(this.date))
            if(this.date.length === 1){
                if(this.type == false){
                    this.$router.push("/examine")
                }else{
                    this.$router.push("/addLeave")
                }
            }
        },
        xuanzhong(item){
            console.log(item)
            item.checked = !item.checked
            this.dataInfo.forEach(items=>{
                if(item.id === items.id){
                    items.checked = !items.checked
                }else{
                    items.checked = false
                }
            })
            this.$forceUpdate()
            this.date = []
            this.dataInfo.forEach((items,index)=>{
                if(items.checked === true){
                    if(this.date.indexOf(items) === -1){
                        this.date.push(items)
                    }
                }
            })
            console.log(this.date.length)
        },
        //点击大部门
        dabumen(item,index){
            this.date = []
            this.data = this.data.splice(0,index+1)
            getSchool(item.id).then(res=>{
                if(res.data.code === 200){
                    console.log(res.data.data)
                    this.schoolInfo = res.data.data[0]
                    this.deptInfo = res.data.data[0].children
                    console.log(this.deptInfo)
                }
            })
            console.log(item)
            let data = {
                needDept: false,
                deptId:item.id,
                "pageNum": 0,
                "pageSize": 100000,
                findInChildren: false
            }
            getStudents(data).then(res=>{
                if(res.data.code === 200){
                    console.log(res.data.data.content)
                    this.dataInfo = res.data.data.content
                }
            })
        },
        //点击部门
        bumen(item){
            this.date = []
            this.data.push({
                "id":item.id,
                "name":item.name
            })
            getSchool(item.id).then(res=>{
                if(res.data.code === 200){
                    console.log(res.data.data)
                    this.schoolInfo = res.data.data[0]
                    this.deptInfo = res.data.data[0].children
                    console.log(this.deptInfo)
                }
            })
            console.log(item)
            let data = {
                needDept: false,
                deptId:item.id,
                "pageNum": 0,
                "pageSize": 100000,
                findInChildren: false
            }
            getStudents(data).then(res=>{
                if(res.data.code === 200){
                    console.log(res.data.data.content)
                    this.dataInfo = res.data.data.content
                }
            })
        },
        getSchool(){
            getSchool(this.currentInfo.deptId).then(res=>{
                if(res.data.code === 200){
                    console.log(res.data.data)
                    this.schoolInfo = res.data.data[0]
                    this.deptInfo = res.data.data[0].children
                    console.log(this.deptInfo)
                    this.data.push({
                        "id":this.schoolInfo.id,
                        "name":this.schoolInfo.name
                    })
                }
            })
            let data = {
                needDept: false,
                deptId:this.currentInfo.deptId,
                "pageNum": 0,
                "pageSize": 100000,
                findInChildren: false
            }
            getStudents(data).then(res=>{
                if(res.data.code === 200){
                    console.log(res.data.data.content)
                    this.dataInfo = res.data.data.content
                }
            })
        }
    },
    mounted(){
        this.getSchool()
        if(this.$route.query.type){
            this.type = false
            console.log(this.$route.query.type)
        }
        console.log(this.type)
    }
}
</script>

<style scoped>
    .shenpi{
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #ccc;
    }
    .boxing{
        width: 100%;
        background-color: #fff;
    }
    .box{
      width: calc(100% - 2rem);
      margin: 0 auto;
      background-color: #fff;
      margin-bottom: 1.5rem;
    }
    .box-top{
        width: 100%;
        min-height: 4rem;
        background-color: #fff;
        line-height: 4rem;
    }
    .box-center{
        width: 100%;
        height: 2.5rem;
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .div1{
        height: 2.5rem;
        line-height: 2.5rem;
    }
    .div2{
        width: 0.44rem;
        height: 0.75rem;
        background: url("../img/kuohao.png");
        background-size:100% 100%;
    }
    .box-bottom{
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
    }
    .box-bottom-content{
        width: 100%;
        height: 4rem;
        display: flex;
        align-items: center;
    }
    .img{
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        background-color: #00B893;
        margin-left: 1rem;
        line-height: 3rem;
        text-align: center;
        font-size: 1.5rem;
        color: #fff;
    }
    .div{
        height: 4rem;
        line-height: 4rem;
        font-size: 1.25rem;
        margin-left: 1rem;
    }
    .bottom{
        height: 4rem;
        box-sizing: border-box;
        border-top: 1px solid #ccc;
        position: fixed;
        bottom: 0rem;
        width: 100%;
        background-color: #fff;
    }
    .bottom-box{
        height: 100%;
        width: calc(100% - 2rem);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bottom-box div{
        height: 100%;
        line-height: 4rem;
        font-size: 1rem;
    }
</style>